<ol class="breadcrumb">
  <li *ngFor="let breadcrumb of breadcrumbs">
    <!-- <span [routerLink]="breadcrumb.url" routerLinkActive="router-link-active"> -->
    <span [routerLink]="breadcrumb.urls | localizedLink" routerLinkActive="router-link-active">
      {{ breadcrumb.label }}
    </span>
  </li>
</ol>
